module.exports = __webpack_public_path__ + "img/kallang (2).9a30d618.jpg";